import React, { lazy } from 'react'
import HorizontalCard from '../HorizontalCard'
import { PromotionBadge } from '../../Badge'
import { conferenceConfig, FLAGS } from '../../../config'
import { useFlagsContext, useTimeTravel } from '../../../providers'
import { parseMsToISO } from '../../helpers'
import useExhibitorMutation from '../../../components/dashboard/hooks/useExhibitorMutation'

const ArchiveActions = lazy(() => import('../../buttons/ArchiveActionsButtons'))

export default function HorizontalPromotionCard({
  data,
  basePath,
  showArchiveButton,
  booth,
  addProfile,
  headingLevel = 'h3',
}) {
  const { getNow } = useTimeTravel()
  const { [FLAGS.ARCHIVE_ACTIONS]: archiveActionsFlag } = useFlagsContext()
  const { mutateExhibitor } = useExhibitorMutation()

  const deadline = conferenceConfig.promotionsEditDeadlineTimestamp
  const isLocked = parseMsToISO(getNow()) > deadline

  const removePromotion = async (id) => {
    const updatedPromotions = booth.promotions.filter((promo) => promo.promoId !== id)

    const updatedBooth = await mutateExhibitor({
      id: booth.id,
      locale: booth.contentLocale,
      promotionsBehavior: 'REPLACE_ALL',
      promotions: updatedPromotions.length ? updatedPromotions : [],
    })

    addProfile(updatedBooth)
  }

  return (
    <HorizontalCard
      key={data?.promoId}
      badges={<PromotionBadge />}
      headingLevel={headingLevel}
      data={data}
      description={data.description}
      to={`${basePath}${data?.promoId}`}
      contentId={data.id}
      isLocked={isLocked || undefined}
      actions={
        showArchiveButton && archiveActionsFlag.isOn && <ArchiveActions data={data} removeData={removePromotion} />
      }
    />
  )
}
